import * as ActionTypes from './action-types';

function loadFontRequest(state) {
  return {
    ...state,
    isLoadingFont: true,
  };
}

function loadFontSuccess(state, { fontIndex }) {
  return {
    ...state,
    isLoadingFont: false,
    currentFontIndex: fontIndex,
  };
}

function loadFontFailure(state) {
  return {
    ...state,
    isLoadingFont: false,
  };
}

const Reducer = (state, action) => {
  switch (action.type) {
    case ActionTypes.LOAD_FONT_REQUEST:
      return loadFontRequest(state);
    case ActionTypes.LOAD_FONT_SUCCESS:
      return loadFontSuccess(state, action.payload);
    case ActionTypes.LOAD_FONT_FAILURE:
      return loadFontFailure(state);
    default:
      return state;
  }
};

export default Reducer;
